import routesName from "../constants/routesName";
import sideBarName from "../constants/sidebar";
import {
  DevicesIcon,
  FeedbackIcon,
  GridIcon,
  HospitalIcon,
  LoginIcons,
  NotificationsIcon,
  PersonIcon,
} from "../components/muiIconsImport";
import { AccessTokenDecoderSync } from "../utils/accessTokenDecoder";
import { useMemo } from "react";

export const useSidebarData = () => {
  const userDetails = AccessTokenDecoderSync();

  const sideBarData = useMemo(() => {
    if (!userDetails) return [];

    const isAdmin =
      userDetails?.Roles === "Super Admin" ||
      userDetails?.Roles === "Management";

    return [
      ...(isAdmin
        ? [
          {
            name: sideBarName.mis,
            path: routesName.managementInfoSystemPage,
            anotherPath: routesName.managementInfoSystemPage,
            icon: GridIcon,
          },
        ]
        : []),
      {
        name: sideBarName.hospitalManagement,
        path: routesName.hospitalManagementPage,
        anotherPath: routesName.hospitalManagementPage,
        icon: HospitalIcon,
      },
      ...(isAdmin
        ? [
          {
            name: sideBarName.accountManagers,
            path: routesName.accountManagerPage,
            anotherPath: routesName.accountManagerPage,
            icon: PersonIcon,
          },
        ]
        : []),
      {
        name: sideBarName.Notification,
        path: routesName.notificationPage,
        anotherPath: routesName.notificationPage,
        icon: NotificationsIcon,
      },
      {
        name: sideBarName.Devices,
        path: `${routesName.devicesPage}/${routesName.alldevice}`,
        anotherPath: `${routesName.devicesPage}`,
        icon: DevicesIcon,
      },
      ...(isAdmin
        ? [
          {
            name: sideBarName.Logins,
            path: routesName.loginsDetailsPage,
            anotherPath: routesName.loginsDetailsPage,
            icon: LoginIcons,
          },
        ]
        : []),
      {
        name: sideBarName.Feedback,
        path: routesName.feedbackPage,
        anotherPath: routesName.feedbackPage,
        icon: FeedbackIcon,
      },
    ];
  }, [userDetails]);

  return sideBarData;
};
